<template>

    <!-- Star Footer
    ============================================= -->
    <footer>
        <div id="nosotros" class="container">
            <div class="f-items default-padding">
                <div class="row">
                    <div class="equal-height col-lg-4 col-md-6 item">
                        <div class="f-item about">
                            <img src="assets/img/logo.png" alt="Logo">
                            <p>
                                Nuestro objetivo es que tengas todo seguro y centralizado, que tus ideas se desarrollen en la web.
                            </p>
                        </div>
                    </div>

                    <div class="equal-height col-lg-4 col-md-6 item text-center">
                        <div class="f-item link">
                            <h4 class="widget-title">Links</h4>
                            <ul>
                                <li>
                                    <a :href="cons.links.soporte.zohoTickets">Portal Tickets Vapp</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!--<div class="equal-height col-lg-2 col-md-6 item">
                        <div class="f-item link">
                            <h4 class="widget-title">Servicios</h4>
                            <ul>
                                <li>
                                    <a href="#">Desarrollo de proyectos</a>
                                </li>
                                <li>
                                    <a href="#">Aplicaciones Vapp/a>
                                </li>
                                <li>
                                    <a href="#">Soporte TI</a>
                                </li>
                                <li>
                                    <a href="#">Digitalización</a>
                                </li>
                                <li>
                                    <a href="#">Big Data</a>
                                </li>
                            </ul>
                        </div>
                    </div>-->

                    <div id="contacto" class="equal-height col-lg-4 col-md-6 item">
                        <div class="f-item contact">
                            <h4 class="widget-title">Información de Contaco</h4>
                            <p>
                                 Puedes Contactarte con nosotros en redes sociales.</p>
                            <div class="address">
                                <ul>
                                    <li>
                                        <strong>Email:</strong> soporte@vapp.cl
                                    </li>
                                    <li>
                                    <strong>Nuestras Redes:</strong> </li>
                                </ul>
                            </div>
                            <ul class="social">
                                <!--<li class="facebook">
                                    <a href="#"><i class="fab fa-facebook-f"></i></a>
                                </li>-->
                                <!--<li class="twitter">
                                    <a href="#"><i class="fab fa-twitter"></i></a>
                                </li>-->
                                <li class="youtube">
                                    <a :href="cons.links.redes.youtubeChannel"><i class="fab fa-youtube"></i></a>
                                </li>
                                <li class="instagram">
                                    <a :href="cons.links.redes.instagram"><i class="fab fa-instagram"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="row">
                    <div class="col-lg-6">
                        <p>&copy; Copyright 2020. All Rights Reserved by <a href="#">Vapp</a></p>
                    </div>
                    <div class="col-lg-6 text-right link">
                        <!--<ul>
                            <li>
                                <a href="#">Terminos</a>
                            </li>
                            <li>
                                <a href="#">Privacidad</a>
                            </li>
                            <li>
                                <a href="#">Soporte</a>
                            </li>
                        </ul>-->
                    </div>
                </div>
            </div>
        </div>
        <!-- Shape -->
        <div class="footer-shape" style="background-image: url(assets/img/shape/1.svg);"></div>
        <!-- End Shape -->
    </footer>
    <!-- End Footer-->

</template>


<script>
    import cons from '@/utils/const';
    export default {
        name: "BannerFooter",
        components: {},
        data() {
            return { cons };
        },
        beforeMount() {},
    };
</script>